import { BackgroundProvider } from '@tribeplatform/react-ui-kit/BackgroundContext'

import { ChatMessagesEmptyState } from './ChatMessagesEmptyState.js'
import { NewChat } from './NewChat/NewChat.js'

interface Props {
  newChat?: boolean
}
export const ChatsContainerEmptyState = ({ newChat }: Props) => {
  if (newChat) {
    return <NewChat />
  }

  return (
    <BackgroundProvider backgroundType="surface">
      <div className="hidden sm:flex flex-col h-full w-full sm:rounded-base bg-surface">
        <ChatMessagesEmptyState />
      </div>
    </BackgroundProvider>
  )
}
